import { VIEW_PAYOUTS } from "@/utils/enums/permissions";

export default [
  {
    name: "payouts.index",
    path: "/business/:businessId/payouts",
    component: () =>
      import(
        /* webpackChunkName: "payout-module" */ "@/v2/module/payout/main/Main.vue"
      ),
    props: true,
    meta: {
      title: "Payouts",
      permission: VIEW_PAYOUTS,
    },
  },
];
